import { render, staticRenderFns } from "./enquirylist.vue?vue&type=template&id=0771bd2e&scoped=true"
import script from "./enquirylist.vue?vue&type=script&lang=js"
export * from "./enquirylist.vue?vue&type=script&lang=js"
import style0 from "./enquirylist.vue?vue&type=style&index=0&id=0771bd2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0771bd2e",
  null
  
)

export default component.exports